import type { SVGProps } from "react";
// generated from EyeOff.svg — do not edit manually
// prettier-ignore
export default function EyeOff(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    
        <path d="M 12 8 C 12.4102 8 12.8062 8.061 13.1787 8.176 C 13.0647 8.427 13 8.706 13 9 C 13 10.105 13.8954 11 15 11 C 15.2939 11 15.5719 10.934 15.8232 10.82 C 15.9382 11.193 16 11.589 16 12 C 16 14.209 14.2091 16 12 16 C 9.79086 16 8 14.209 8 12 C 8 9.791 9.79086 8 12 8 Z" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M 12 5 C 18.0751 5 23 12 23 12 C 23 12 18.0751 19 12 19 C 5.92487 19 1 12 1 12 C 1 12 5.92487 5 12 5 Z" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M 2 2 L 22 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    
</svg>);
}
